import _ from 'lodash';
import { SearchFilterValues } from '../../../../logic/domains/searchFilters.domain';

export const countFilters = (
	initialFilters: SearchFilterValues,
	searchFilters: SearchFilterValues
) => {
	let filterCount = 0;

	for (let [key, value] of Object.entries(searchFilters)) {
		if (['postcode', 'insuranceOptions'].includes(key)) {
			if (!_.isEqual(value, initialFilters[key])) {
				filterCount++;
			}
		}

		if (
			[
				'investmentOptions',
				'insuranceType',
				'insuranceAnniversary',
				'policyStatus',
			].includes(key)
		) {
			if (!_.isEqual(value, initialFilters[key]) && value !== 'any') {
				filterCount++;
			}
		}
	}

	if (
		!searchFilters.accountType.includes('all') &&
		searchFilters.accountType.length !== 0
	) {
		filterCount++;
	}

	if (
		!searchFilters.investmentType.includes('all') &&
		searchFilters.investmentType.length !== 0
	) {
		filterCount++;
	}

	if (searchFilters.ageMin || searchFilters.ageMax) {
		filterCount++;
	}

	if (searchFilters.includeClosedAccounts) {
		filterCount++;
	}
	if (searchFilters.showLinkedAccountsOnly) {
		filterCount++;
	}
	if (
		(searchFilters.advisedPortfolioMin &&
			searchFilters.advisedPortfolioMin !== 'any') ||
		(searchFilters.advisedPortfolioMax &&
			searchFilters.advisedPortfolioMax !== 'any')
	) {
		filterCount++;
	}

	if (searchFilters.insuranceAmountMin || searchFilters.insuranceAmountMax) {
		filterCount++;
	}

	if (searchFilters.annualPremiumMin || searchFilters.annualPremiumMax) {
		filterCount++;
	}

	return filterCount;
};
